const AuthLeftPanel = () => {
    return (
        <div className="min-h-screen w-full bg-white pl-6 md:pl-10 py-14 flex items-center font-['Raleway'] justify-center">
            <div className="w-full h-full bg-[url('/images/Auth-Pages/backg.jpg')] bg-cover bg-center bg-no-repeat rounded-[20px] p-10 flex flex-col items-center relative overflow-hidden">

                {/* Top Text Content */}
                <div className="w-full text-left mt-4 mb-16 self-start">
                    <h1 className="text-[38px] font-bold text-white leading-[1.4] mb-4">
                        Build Predictable Influencer<br /> Campaigns
                    </h1>
                    <p className="text-lg italic text-white font-normal leading-relaxed max-w-[80%]">
                        *Discover, evaluate, and manage influencers using real performance data — not guesswork.*
                    </p>
                </div>

                {/* Center UI Image Placeholder (Add your image here) */}
                <div className="w-full max-w-[800px] flex justify-center items-center my-12 relative z-10">
                    <img
                        src="/images/Auth-Pages/Card.png"
                        alt="Influencer Campaign Platform UI"
                        className="w-full h-auto object-contain"
                    />
                </div>

                {/* Bottom Text */}
                <div className="w-full text-center mt-auto">
                    <p className="text-lg text-black font-normal italic">
                        Used by agencies & brand to scale influencer marketing.
                    </p>
                </div>

            </div>
        </div>

    );
};

export default AuthLeftPanel;